// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

export var breakpoint = {
  xs: {
    max: 575
  },
  sm: {
    min: 576,
    max: 767
  },
  md: {
    min: 768,
    max: 991
  },
  lg: {
    min: 992,
    max: 1199
  },
  xl: {
    min: 1200
  }
};
export var color = {
  light: {
    foreground: {
      "default": '#212121',
      medium: '#404040',
      light: '#666666',
      disabled: '#a3a3a3'
    },
    background: {
      "default": '#fafafa',
      medium: '#f0f0f0',
      container: {
        "default": '#ffffff',
        hover: '#f5f5f5',
        active: '#f0f0f0'
      },
      disabled: '#e0e0e0'
    },
    stroke: {
      "default": '#e0e0e0'
    },
    effects: {
      glasswall: 'rgba(33,33,33,0.5)',
      dropShadow: 'rgba(33,33,33,0.2)',
      highlight: {
        "default": 'rgba(59,183,246,0.1)',
        hover: 'rgba(115,207,254,0.3)',
        active: 'rgba(159,224,254,0.6)'
      }
    },
    spotlight: {
      foreground: {
        "default": '#212121',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#ffffff',
        hover: 'rgba(255,255,255,0.8)',
        active: 'rgba(255,255,255,0.6)'
      },
      background: {
        "default": '#212121',
        hover: 'rgba(255,255,255,0.1)',
        active: 'rgba(255,255,255,0.2)'
      }
    },
    primary: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#0073a8',
        hover: '#015985',
        active: '#02476b'
      },
      background: {
        "default": '#e6f0f5',
        hover: '#ceeffe',
        active: '#b7e8fe'
      }
    },
    neutral: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#666666',
        hover: '#545454',
        active: '#404040'
      },
      background: {
        "default": '#f5f5f5',
        hover: 'rgba(163,163,163,0.1)',
        active: 'rgba(163,163,163,0.2)'
      }
    },
    positive: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#007d48',
        hover: '#006c3e',
        active: '#005a35'
      },
      background: {
        "default": '#defff1',
        hover: '#ccffe8',
        active: '#a3ffd6'
      }
    },
    caution: {
      foreground: {
        "default": '#5c4e00',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#ffe137',
        hover: '#f9d300',
        active: '#e5c300'
      },
      background: {
        "default": '#f7f2cb',
        hover: '#fff29e',
        active: '#ffe970'
      }
    },
    warning: {
      foreground: {
        "default": '#212121',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#ff8900',
        hover: '#e07200',
        active: '#b2600c'
      },
      background: {
        "default": '#ffedde',
        hover: '#ffdbb2',
        active: '#ffc98c'
      }
    },
    negative: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#cc2c00',
        hover: '#9f2301',
        active: '#802208'
      },
      background: {
        "default": '#faeceb',
        hover: '#ffdbd9',
        active: '#ffc1bd'
      }
    },
    help: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#187585',
        hover: '#176673',
        active: '#16555f'
      },
      background: {
        "default": '#d7f4f7',
        hover: '#d4fbff',
        active: '#bcf7ff'
      }
    },
    accent: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#000000',
        hover: '#292929',
        active: '#404040'
      },
      background: {
        "default": '#fafafa',
        hover: '#f0f0f0',
        active: '#e0e0e0'
      }
    },
    focus: {
      "default": '#02476b',
      inverse: '#ffffff'
    }
  },
  dark: {
    foreground: {
      "default": '#ffffff',
      medium: '#e0e0e0',
      light: '#a3a3a3',
      disabled: '#666666'
    },
    background: {
      "default": '#212121',
      medium: '#303030',
      container: {
        "default": '#292929',
        hover: '#303030',
        active: '#404040'
      },
      disabled: '#404040'
    },
    stroke: {
      "default": '#545454'
    },
    effects: {
      glasswall: 'rgba(33,33,33,0.7)',
      dropShadow: 'rgba(0,0,0,0.4)',
      highlight: {
        "default": 'rgba(0,115,168,0.1)',
        hover: 'rgba(1,89,133,0.3)',
        active: 'rgba(2,71,107,0.6)'
      }
    },
    spotlight: {
      foreground: {
        "default": '#ffffff',
        hover: '#ffffff',
        active: '#ffffff'
      },
      base: {
        "default": '#212121',
        hover: 'rgba(33,33,33,0.8)',
        active: 'rgba(33,33,33,0.6)'
      },
      background: {
        "default": '#ffffff',
        hover: 'rgba(33,33,33,0.1)',
        active: 'rgba(33,33,33,0.2)'
      }
    },
    primary: {
      foreground: {
        "default": '#212121',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#3bb7f6',
        hover: '#73cffe',
        active: '#9fe0fe'
      },
      background: {
        "default": '#112d3b',
        hover: '#0e3245',
        active: '#0a3b54'
      }
    },
    neutral: {
      foreground: {
        "default": '#212121',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#a3a3a3',
        hover: '#c2c2c2',
        active: '#e0e0e0'
      },
      background: {
        "default": '#303030',
        hover: 'rgba(125,125,125,0.1)',
        active: 'rgba(125,125,125,0.2)'
      }
    },
    positive: {
      foreground: {
        "default": '#212121',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#00d072',
        hover: '#4ef5ab',
        active: '#78ffc2'
      },
      background: {
        "default": '#093021',
        hover: '#07412a',
        active: '#034c2e'
      }
    },
    caution: {
      foreground: {
        "default": '#212121',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#ffe137',
        hover: '#ffe970',
        active: '#fff29e'
      },
      background: {
        "default": '#302900',
        hover: '#413700',
        active: '#544700'
      }
    },
    warning: {
      foreground: {
        "default": '#212121',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#ff8900',
        hover: '#ffa238',
        active: '#ffb866'
      },
      background: {
        "default": '#382514',
        hover: '#4a3016',
        active: '#5c3a19'
      }
    },
    negative: {
      foreground: {
        "default": '#212121',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#ff6a4d',
        hover: '#ff8373',
        active: '#ffa59e'
      },
      background: {
        "default": '#422016',
        hover: '#522112',
        active: '#68240f'
      }
    },
    help: {
      foreground: {
        "default": '#212121',
        hover: '#212121',
        active: '#212121'
      },
      base: {
        "default": '#2ac5e0',
        hover: '#40defa',
        active: '#8aefff'
      },
      background: {
        "default": '#142c30',
        hover: '#173e45',
        active: '#15474f'
      }
    },
    accent: {
      foreground: {
        "default": '#000000',
        hover: '#000000',
        active: '#000000'
      },
      base: {
        "default": '#ffffff',
        hover: '#f0f0f0',
        active: '#e0e0e0'
      },
      background: {
        "default": '#212121',
        hover: '#292929',
        active: '#303030'
      }
    },
    focus: {
      "default": '#9fe0fe',
      inverse: '#292929'
    }
  },
  highContrast: {
    foreground: {
      "default": '#ffffff',
      medium: '#ffffff',
      light: '#ffffff',
      disabled: '#adadad'
    },
    background: {
      "default": '#16141d',
      medium: '#16141d',
      container: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      disabled: '#545454'
    },
    stroke: {
      "default": '#adadad'
    },
    effects: {
      glasswall: '#16141d',
      dropShadow: 'rgba(22,20,29,0)',
      highlight: {
        "default": 'rgba(22,20,29,0)',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    spotlight: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#fff700',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#ffffff',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    primary: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#fff700',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    neutral: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#fff700',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    positive: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#00d072',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    warning: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#ff8900',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    caution: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#ffe137',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    negative: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#ff6a4d',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    help: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#2ac5e0',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    accent: {
      foreground: {
        "default": '#16141d',
        hover: '#16141d',
        active: '#16141d'
      },
      base: {
        "default": '#fff700',
        hover: '#fe6aff',
        active: '#00d3ff'
      },
      background: {
        "default": '#16141d',
        hover: '#fe6aff',
        active: '#00d3ff'
      }
    },
    focus: {
      "default": '#00d3ff',
      inverse: '#16141d'
    }
  }
};
export var elevation = {
  level20: {
    offsetX: 0,
    offsetY: 5,
    blur: 20,
    spread: 5,
    boxShadow: '0px 5px 20px 5px'
  },
  glasswall: {
    offsetX: 0,
    offsetY: 0,
    blur: 16,
    spread: 0,
    boxShadow: '0px 0px 16px 0px'
  },
  level16: {
    offsetX: 0,
    offsetY: 4,
    blur: 16,
    spread: 4,
    boxShadow: '0px 4px 16px 4px'
  },
  level12: {
    offsetX: 0,
    offsetY: 3,
    blur: 12,
    spread: 3,
    boxShadow: '0px 3px 12px 3px'
  },
  level8: {
    offsetX: 0,
    offsetY: 2,
    blur: 8,
    spread: 2,
    boxShadow: '0px 2px 8px 2px'
  },
  level4: {
    offsetX: 0,
    offsetY: 1,
    blur: 4,
    spread: 1,
    boxShadow: '0px 1px 4px 1px'
  }
};
export var shape = {
  round: {
    borderRadius: 12
  },
  sharp: {
    borderRadius: 0
  },
  pill: {
    borderRadius: 12
  }
};
export var spacing = {
  standard: {
    borderRadius: {
      one: 12,
      two: 8,
      three: 16
    },
    padding: {
      one: 4,
      two: 8,
      three: 12,
      four: 16,
      five: 20,
      six: 24,
      seven: 28,
      eight: 32,
      intermediate: 12
    }
  },
  high: {
    borderRadius: {
      one: 8,
      two: 8,
      three: 12
    },
    padding: {
      one: 0,
      two: 4,
      three: 8,
      four: 12,
      five: 16,
      six: 20,
      seven: 24,
      eight: 28,
      intermediate: '6'
    }
  }
};
export var typography = {
  small: {
    titleLarge: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '36px',
      fontWeight: 400,
      lineHeight: '44px'
    },
    titleMedium: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '28px',
      fontWeight: 400,
      lineHeight: '36px'
    },
    titleRegular: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '24px',
      fontWeight: 400,
      lineHeight: '32px'
    },
    titleSmall: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '20px',
      fontWeight: 400,
      lineHeight: '28px'
    },
    subtitleLarge: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '18px',
      fontWeight: 400,
      lineHeight: '24px'
    },
    subtitleRegular: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '20px'
    },
    overlineLarge: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '20px'
    },
    overlineRegular: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '16px'
    },
    bodyLarge: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px'
    },
    bodyRegular: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '20px'
    },
    labelRegular: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '20px'
    },
    labelSmall: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '16px'
    },
    captionRegular: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px'
    },
    captionSmall: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '16px'
    }
  },
  medium: {
    titleLarge: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '56px',
      fontWeight: 400,
      lineHeight: '64px'
    },
    titleMedium: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '40px',
      fontWeight: 400,
      lineHeight: '48px'
    },
    titleRegular: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '32px',
      fontWeight: 400,
      lineHeight: '40px'
    },
    titleSmall: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '24px',
      fontWeight: 400,
      lineHeight: '32px'
    },
    subtitleLarge: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '20px',
      fontWeight: 400,
      lineHeight: '28px'
    },
    subtitleRegular: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '18px',
      fontWeight: 400,
      lineHeight: '24px'
    },
    overlineLarge: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '18px',
      fontWeight: 400,
      lineHeight: '24px'
    },
    overlineRegular: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '16px'
    },
    bodyLarge: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px'
    },
    bodyRegular: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '24px'
    },
    labelRegular: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '20px'
    },
    labelSmall: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '16px'
    },
    captionRegular: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px'
    },
    captionSmall: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '16px'
    }
  },
  large: {
    titleLarge: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '72px',
      fontWeight: 400,
      lineHeight: '84px'
    },
    titleMedium: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '56px',
      fontWeight: 400,
      lineHeight: '64px'
    },
    titleRegular: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '40px',
      fontWeight: 400,
      lineHeight: '48px'
    },
    titleSmall: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '32px',
      fontWeight: 400,
      lineHeight: '40px'
    },
    subtitleLarge: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '24px',
      fontWeight: 400,
      lineHeight: '32px'
    },
    subtitleRegular: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '20px',
      fontWeight: 400,
      lineHeight: '28px'
    },
    overlineLarge: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '20px',
      fontWeight: 400,
      lineHeight: '28px'
    },
    overlineRegular: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px'
    },
    bodyLarge: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '18px',
      fontWeight: 400,
      lineHeight: '24px'
    },
    bodyRegular: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px'
    },
    labelRegular: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '20px'
    },
    labelSmall: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '16px'
    },
    captionRegular: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px'
    },
    captionSmall: {
      fontFamily: "'Forma DJR UI', Arial, sans-serif",
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '16px'
    }
  }
};
var semantics = {
  breakpoint: breakpoint,
  color: color,
  elevation: elevation,
  shape: shape,
  spacing: spacing,
  typography: typography
};
export default semantics;